import { CircularProgress } from "@material-ui/core";
import React from "react";

export default function LoadingPage(){
  return <div>
  <br/><br/>
  &nbsp;&nbsp;&nbsp;&nbsp;<CircularProgress size={24}/>
  </div>
}